<template>
  <div class="v-meida-holder">
  <img class="v-media" :src="image" />
  </div>
  <!-- <v-card-media
  class="white--text"
  height="auto"
  maxHeight="150px"
  backgroundSize="contain"
  :src="image"
  >
  </v-card-media> -->
</template>


<script>
export default {
  name: 'item-media',
  props: ['value'],
  computed: {
    image () {
      return this.value.images === null || this.value.images.length === 0 ? '/static/img/image_placeholder.jpg' : this.value.images[0]
    }
  }
}
</script>
<style>
.v-meida-holder{text-align: center;}
img.v-media{height: auto;max-height: 150px;}
</style>



// WEBPACK FOOTER //
// Media.vue?3cfd9161